<div class="div-action-top">
  <div class="left">
    <div class="form-filter ant-form ant-form-inline">
      <form nz-form [nzLayout]="'inline'" [formGroup]="filterForm" class="form-filter aligns-item-center" (ngSubmit)="doSearch()">
        <nz-form-item class="spacepad">
          <nz-form-control>
            <nz-date-picker formControlName="fromDate" nzPlaceHolder="Từ ngày..." nzFormat="dd/MM/yyyy" nzSize="default">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="spacepad">
          <nz-form-control>
            <nz-date-picker formControlName="toDate" nzPlaceHolder="Đến ngày..." nzFormat="dd/MM/yyyy" nzSize="default">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </form>
      <button style="margin-right: 5px" nz-button nzType="primary" nzSize="default" (click)="doSearch()">Tìm kiếm</button>
      <button style="margin-right: 5px" nz-button nzType="primary" nzSize="default" type="button" (click)="showModalAdd()" *ngIf="checkAdd">
        <em class="fas fa-plus fa-fw"></em> Thêm phiếu nhập kho
      </button>
      <button nz-button nzType="primary" nzSize="default" class="btn-green" type="button" (click)="export()">
        Xuất excel</button>
    </div>
  </div>
</div>
<!-- <div class="data-table">
  <nz-table #basicTable [nzData]="filterData" (nzCurrentPageDataChange)="currentPageDataChange($event)"
            [nzPageSizeOptions]="pageSize" [nzPageSize]="defaultPage" nzSize="small" nzShowSizeChanger
            [nzScroll]="{x: '800px'}"
            [nzShowTotal]="rangeTemplate" [nzLoading]="loading">
    <thead>
    <tr>
      <th nzShowCheckbox nzLeft="0px" nzWidth="50px" [(nzChecked)]="isAllDisplayDataChecked"
          [nzIndeterminate]="isIndeterminate" (nzCheckedChange)="checkAllRow($event)"></th>
      <th nzLeft class="text-nowrap" width="50px">#</th>
      <th nzLeft class="text-nowrap" width="150px">Mã phiếu</th>
      <th nzLeft class="text-nowrap" width="150px">Mô tả phiếu</th>
      <th class="text-nowrap" width="150px">Nhà cung cấp</th>
      <th class="text-nowrap" width="150px" nzFormat="dd/MM/yyyy HH:mm">Thời gian nhập</th>
      <th class="text-nowrap" width="150px">Người nhập</th>
      <th class="text-nowrap" width="150px">Tiền thanh toán</th>
      <th class="text-nowrap" width="150px">Mã HĐ thanh toán</th>
      <th nzRight class="text-nowrap" width="150px">Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of basicTable.data;let i = index;">
      <td nzShowCheckbox [(nzChecked)]="mapOfCheckedId[data.id]" (nzCheckedChange)="refreshStatus()" nzLeft="0px"
          nzWidth="50px"></td>
      <td nzLeft class="text-nowrap">{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
      <td nzLeft class="text-nowrap">{{ data.code }}</td>
      <td nzLeft class="">{{ data.description }}</td>
      <td class="">{{ data.supplier }}</td>
      <td class="text-nowrap">{{ data.inputDate | date:'dd/MM/yyyy HH:mm' }}</td>
      <td class="text-nowrap">{{ data.inputUser.fullname }}</td>
      <td class="text-nowrap">{{ data.paymentAmount | number:'1.0-2' }}</td>
      <td class="text-nowrap">{{ data.paymentCode }}</td>
      <td nzRight class="text-nowrap">
        <button nz-button nzType="danger" nzSize="small" class="btn-right" (click)="showConfirm(data.id)"
                *ngIf="checkDelete"><span class="fa fa-times fa-fw"></span>
        </button>
        <button nz-button nzType="primary" nzSize="small" class="btn-right" (click)="showDetails(data)"
                *ngIf="checkDetails"><span class="fa fa-info fa-fw"></span>
        </button>
        <button nz-button nzType="default" nzSize="small" title="In barcode" class="btn-right"
                (click)="popupPrintBarcode(data)">
          <span class="fa fa-barcode fa-fw "></span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <ng-template #rangeTemplate let-range="range" let-total>
    {{ range[0] }}-{{ range[1] }} {{'of' | translate }} {{ total }} {{'items' | translate }}
  </ng-template>
</div> -->

<dx-data-grid id="gridContainer"
  [dataSource]="dataFullDetail"
  [showColumnLines]="true"
  [showRowLines]="true"
  [height]="dxGridHeight"
  [rowAlternationEnabled]="true"
  [showBorders]="true"
  [allowColumnResizing]="true"
  columnResizingMode="widget"
  [columnMinWidth]="50"
  [columnAutoWidth]="true"
  [showBorders]="true"
  (onExporting)="onExporting($event)"
  [wordWrapEnabled]="true">
  <dxo-load-panel [enabled]="true"></dxo-load-panel>
  <dxo-scrolling mode="virtual"></dxo-scrolling>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-filter-row [visible]="true" [applyFilter]="dataFullDetail"></dxo-filter-row>

  <dxi-column cssClass="text-center" caption="Action" [width]="120" [fixed]="true" cellTemplate="cellBtnAction"></dxi-column>
  <dxi-column caption="Mã phiếu" [width]="150" dataField="code" [fixed]="true"></dxi-column>
  <dxi-column caption="Mô tả phiếu" [width]="150" dataField="description" [fixed]="true"></dxi-column>
  <dxi-column caption="Nhà cung cấp" dataField="supplier" [width]="200" [fixed]="true"></dxi-column>
  <dxi-column caption="Thời gian nhập" [width]="180" dataField="inputDate" dataType="date" format="HH:mm dd/MM/yy"></dxi-column>
  <dxi-column caption="Người nhập" [width]="150" dataField="inputUserName"></dxi-column>
  <dxi-column caption="Tiền thanh toán" [width]="180" dataField="" format=",##0.###"></dxi-column>
  <dxi-column caption="Số HDTC" [width]="100" dataField="hdtcnumber"></dxi-column>
  <dxi-column caption="Mã HC" [width]="100" dataField="chemicalCode"></dxi-column>
  <dxi-column caption="Tên hóa chất" [width]="200" dataField="chemicalName"></dxi-column>
  <dxi-column caption="Số lượng" [width]="150" dataField="amount"></dxi-column>
  <dxi-column caption="Đơn giá" [width]="150" dataField="price" format=",##0.###"></dxi-column>
  <dxi-column caption="Thành tiền" [width]="150" dataField="totalPrice" format=",##0.###"></dxi-column>
  <dxi-column caption="Hãng SX" [width]="150" dataField="madeIn"></dxi-column>
  <dxi-column caption="Code NSX" [width]="150" dataField="manufacturerCode"></dxi-column>
  <dxi-column caption="Seri" [width]="150" dataField="serialNumber"></dxi-column>
  <dxi-column caption="Hạn sử dụng" [width]="150" dataField="expiredDate" dataType="date" format="dd/MM/yyyy" cellTemplate="cellExpiredDate"></dxi-column>
  <dxi-column caption="Số lô" [width]="150" dataField="batchNumber"></dxi-column>
  <dxi-column caption="Quy cách đóng gói" [width]="150" dataField="chemicalPacking" cellTemplate="cellPacking"></dxi-column>
  <dxi-column cssClass="text-center" caption="Barcode" [width]="80" [fixed]="true" fixedPosition="right" cellTemplate="cellBtnBarcode"></dxi-column>

  <dxo-summary>
    <dxi-total-item
      column="code"
      displayFormat="Số phiếu: {0}"
      summaryType="count">
    </dxi-total-item>
  </dxo-summary>
  <div [ngClass]="{'warning-text': item.data.isWarningExpired}" *dxTemplate="let item of 'cellExpiredDate'">
    {{item.data.expiredDate | date: 'dd/MM/yyyy' }}
  </div>
  <div *dxTemplate="let item of 'cellPacking'">
    {{item.data.chemicalPackingQuantity }} {{item.data.chemicalPackingUnit}}/{{item.data.chemicalPacking}}
  </div>
  <div *dxTemplate="let item of 'cellBtnAction'">
    <button *ngIf="item.data.code" nz-button nzType="danger" nzSize="small" class="btn-right" (click)="showConfirm(item.data.id)"
            ><span class="fa fa-times fa-fw"></span>
    </button>
    <button *ngIf="item.data.code" nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
            (click)="exportPDF(item.data.id)">
      <span class="fas fa-file-pdf fa-fw"></span>
    </button>
    <button *ngIf="item.data.code && item.data.status == 1" nz-button nzType="primary" nzSize="small" class="btn-right" (click)="showModalEdit(item.data.id)"
            ><span class="fa fa-edit fa-fw"></span>
    </button>
  </div>
  <div *dxTemplate="let item of 'cellBtnBarcode'">
    <button *ngIf="item.data.status !== 1" nz-button nzType="default" nzSize="small" title="In barcode" class="btn-center"
              (click)="popupPrintBarcodeChemical(item.data)">
          <span class="fa fa-barcode fa-fw "></span>
    </button>
  </div>
</dx-data-grid>


<nz-modal [nzWidth]="1200" [(nzVisible)]="isVisibleAdd" nzClosable="false" [nzTitle]="title1" nzMaskClosable="false">
  <ng-template #title1>
    Thông tin phiếu nhập kho
    <div class="pull-right icon-close">
      <em (click)="handleCancel()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <nz-spin [nzSpinning]="loadingButton">
    <form [formGroup]="formAdd" *ngIf="enableEdit" (ngSubmit)="handleOk()">
      <div class="input-wrap nz-row row-width">
        <label class="title-detail text-text" nz-col [nzSpan]="4">Mã phiếu</label>
        <nz-form-control [nzSpan]="12" style="position: relative;">
          <input formControlName="code" nz-input placeholder="Mã sẽ tự thêm nếu ô bỏ trống ..." [disabled]='true'/>
        </nz-form-control>
      </div>
      <div class="input-wrap nz-row row-width">
        <label class="title-detail text-text" nz-col [nzSpan]="4">Mô tả phiếu<em
          class="fa fa-asterisk required"></em></label>
        <div nz-col [nzSpan]="12">
          <input nz-input placeholder="Mô tả phiếu" formControlName="description"/>
        </div>
      </div>
      <div class="input-wrap nz-row row-width">
        <label class="title-detail text-text" nz-col [nzSpan]="4">Nhà cung cấp
          <em class="fa fa-asterisk required"></em></label>
        <div nz-col [nzSpan]="12">
          <nz-select style="width: 100%" nzShowSearch formControlName="supplier" nzPlaceHolder="Chọn nhà cung cấp">
            <nz-option *ngFor="let cat of suppliers" [nzValue]="cat.name" [nzLabel]="cat.name"></nz-option>
          </nz-select>
        </div>
      </div>
      <div class="input-wrap nz-row row-width">
        <label class="title-detail text-text" nz-col [nzSpan]="4">Tiền thanh toán</label>
        <div nz-col [nzSpan]="12">
          <dx-number-box formControlName="paymentAmount" format="#,##0"></dx-number-box>
        </div>
      </div>
      <!-- <div class="input-wrap nz-row row-width">
        <label class="title-detail text-text" nz-col [nzSpan]="4">Mã HĐ thanh toán</label>
        <div nz-col [nzSpan]="12">
          <input nz-input placeholder="Mã hóa đơn thanh toán" formControlName="paymentCode"/>
        </div>
      </div> -->
    </form>

    <div class="div-action">
      <button nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
              (click)="addDetailInput()"
              *ngIf="checkAdd">
        <em class="fas fa-plus fa-fw"></em>
      </button>
      <div class="clearfix"></div>
    </div>

    <nz-table class="editable-table" #spreadsheet [nzData]="inputWarehouseDetails" [nzScroll]="{ y: '250px' }">
      <thead>
      <tr>
        <th nzWidth="60px"></th>
        <th class="text-center" nzWidth="50px">STT</th>
        <th nzWidth="100px">Số HĐTC</th>
        <th nzWidth="250px">Tên vật tư hóa chất<em class="fa fa-asterisk required"></em></th>
        <th nzWidth="200px">Code NSX</th>
        <th nzWidth="100px">Hãng SX</th>
        <th nzWidth="100px">Số lô</th>
        <th nzWidth="180px">Hạn sử dụng<em class="fa fa-asterisk required"></em></th>
        <th nzWidth="100px">Seri</th>
        <th nzWidth="150px">Đơn vị nhỏ nhất</th>
        <th nzWidth="150px">Quy cách đóng gói</th>
        <th nzWidth="80px">Đơn vị<em class="fa fa-asterisk required"></em></th>
        <th nzWidth="80px">Số lượng<em class="fa fa-asterisk required"></em></th>
        <th nzWidth="100px">Đơn giá<em class="fa fa-asterisk required"></em></th>
        <th nzWidth="100px">Thành tiền<em class="fa fa-asterisk required"></em></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of inputWarehouseDetails;let i = index;">
        <td>
          <button nzSize="small" nz-button nzType="danger" class="button-update btn-right"
                  (click)="deleteDetail(data.chemicalId)">
            <span class="fa fa-fw fa-times"></span>
          </button>
        </td>
        <td>{{ i + 1 }}</td>
        <td>
          <input nzType="number" nz-input nz-tooltip tabIndex [index]=" i * 6 + 8" [(ngModel)]="data.hdtcnumber">
        </td>
        <td>
          <div *ngIf="!data.chemical.name">
            <nz-select [(ngModel)]="data.chemical" (ngModelChange)="chooseChemical($event, data)" nzShowSearch tabIndex [index]=" i * 6" style="width:100%;" nzPlaceHolder="Chọn hóa chất"
                       >
              <nz-option *ngFor="let item of chemicals" [nzValue]="item" [nzLabel]="item | packingFormat"></nz-option>
            </nz-select>
          </div>
          <!--[disabled]="isOnlyView && data.chemical.name !== ''"-->
          <div *ngIf="data.chemical.name">
            {{data.chemical.name}}
          </div>
        </td>
         <td>
          <input nz-input nz-tooltip tabIndex [index]=" i * 6 + 4" [(ngModel)]="data.manufacturerCode">
        </td>
        <td>
          <input nz-input nz-tooltip tabIndex [index]=" i * 6 + 5" [(ngModel)]="data.madeIn">
        </td>
        <td>
          <input nz-input nz-tooltip tabIndex [index]=" i * 6 + 9" [(ngModel)]="data.batchNumber">
        </td>
        <td>
          <!--<nz-date-picker style="width:120px;" tabIndex [index]=" i * 6 + 8" [(ngModel)]="data.expiredDate"
                          nzFormat="dd/MM/yyyy"></nz-date-picker>-->

          <dx-date-box (onValueChanged)="log($event)" [ngClass]="{'warning': isWarningExpired}" [(ngModel)]="data.expiredDate" placeholder="dd/MM/yyyy" type="date" [showClearButton]="true" [useMaskBehavior]="true" displayFormat="dd/MM/yyyy"></dx-date-box>

        </td>
        <td>
          <input nz-input nz-tooltip tabIndex [index]=" i * 6 + 6" [(ngModel)]="data.serialNumber">
        </td>
        <td>
          <input [disabled]="true" nz-input nz-tooltip tabIndex [index]=" i * 6 + 10" [(ngModel)]="data.chemical.packingUnit">
        </td>
        <td>
          <input [disabled]="true" nz-input nz-tooltip tabIndex [index]=" i * 6 + 11" [(ngModel)]="data.chemical.packingQuantity">
        </td>
        <td>
          <nz-select [(ngModel)]="data.unitType" *ngIf="data.chemical" style="width: 70px">
            <nz-option [nzValue]="1" [nzLabel]="data.chemical.packing"></nz-option>
            <nz-option [nzValue]="2" [nzLabel]="data.chemical.packingUnit"></nz-option>
          </nz-select>
        </td>
        <td>
          <input nzType="number" (ngModelChange)="calculateTotal(data)" nz-input nz-tooltip tabIndex
                 [index]=" i * 6 + 1"
                 style="width:70px;" min="1" [(ngModel)]="data.amount">
        </td>
        <td>
          <dx-number-box [(ngModel)]="data.price" tabIndex [index]=" i * 6 + 2"
                         (ngModelChange)="calculateTotal(data)" format="#,##0"></dx-number-box>
        </td>
        <td>
          <dx-number-box [(ngModel)]="data.totalPrice" tabIndex [index]=" i * 6 + 3"
                         (ngModelChange)="calculateTotalRevert(data)" format="#,##0"></dx-number-box>
        </td>
      </tr>
      </tbody>
    </nz-table>

    <div *nzModalFooter>
      <button nz-button (click)="handleCancel()">{{'cancel' | translate }}</button>
      <button nz-button nzType="primary" (click)="handleOk()" class="button-submit">Lưu nháp</button>
      <button [disabled]="disableComplete" nz-button nzType="primary" (click)="handleComplete()" class="button-submit">Hoàn thành</button>
    </div>
  </nz-spin>
</nz-modal>

<!-- Hiển thị chi tiết -->
<nz-modal nzClassName="view-modal" class=" ant-select-disabled ant-select-arrow" nzWidth="1200px"
          [(nzVisible)]="isVisibleViewDetail" nzClosable="false" [nzTitle]="title" nzMaskClosable="false">
  <ng-template #title>
    Thông tin phiếu nhập kho
    <div class="pull-right icon-close">
      <em (click)="handleCancelView()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Mã phiếu:</div>
    <div>{{dataView.code}}</div>
  </div>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Mô tả phiếu:</div>
    <div>{{dataView.description}}</div>
  </div>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Nhà cung cấp:</div>
    <div>{{dataView.supplier}}</div>
  </div>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Tiền thanh toán:</div>
    <div>{{dataView.paymentAmount}}</div>
  </div>
  <!-- <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Mã HĐ thanh toán:</div>
    <div>{{dataView.paymentCode}}</div>
  </div> -->
  <br/>
  <div class="div-action">
    <button nz-button nzSize="small" nzType="primary" class="btn-add-asset btn-right" type="button"
            >
      <em class="fas fa-file-pdf fa-fw"></em>
      Xem trước
    </button>
    <div class="clearfix"></div>
  </div>
  <nz-table #spreadsheet class="table" id="detailTable"
            nzShowPagination="false"
            [nzData]="inputWarehouseDetails" [nzScroll]="{ y: '250px' }">
    <thead>
    <tr>
      <th class="text-center" nzWidth="100px">Barcode</th>
      <th nzWidth="50px">STT</th>
      <th nzWidth="100px">Số HĐTC</th>
      <th class="width-large" nzWidth="180px">Tên - mã hóa chất</th>
      <th nzWidth="100px">Code NSX</th>
      <th nzWidth="100px">Hãng SX</th>
      <th nzWidth="100px">Số lô</th>
      <th class="width-large" nzWidth="120px">Hạn sử dụng</th>
      <th nzWidth="100px">Seri</th>
      <th nzWidth="150px">Đơn vị nhỏ nhất</th>
      <th nzWidth="150px">Quy cách đóng gói</th>
      <th nzWidth="100px">Đơn vị</th>
      <th class="width-small" nzWidth="100px">Số lượng</th>
      <th class="width-small" nzWidth="120px">Đơn giá</th>
      <th class="width-small" nzWidth="120px">Thành tiền</th>
      <!--<th class="width-large" nzWidth="120px">Mã lô</th>-->
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of spreadsheet.data;let i = index;">
      <td>
        <button nz-button nzType="default" nzSize="small" title="In barcode" class="btn-right"
              (click)="popupPrintBarcodeChemical(data)">
          <span class="fa fa-barcode fa-fw "></span>
        </button>
      </td>
      <td class="text-center">{{ i + 1 }}</td>
      <td>{{ data.hdtcnumber }}</td>
      <td>
        <!--<nz-select nzShowSearch [disabled]="true" [nzServerSearch]="true" [(ngModel)]="data.chemicalId">
          <nz-option *ngFor="let cat of chemicals" [nzValue]="cat.id" [nzLabel]="cat.name + ' (' + cat.packingUnit + ' '  + cat.unitValue +  cat.consumableUnit + ')'"></nz-option>
        </nz-select>-->
        {{ data.chemical?.name }}
      </td>
      <td>{{ data.manufacturerCode }}</td>
      <td>{{ data.madeIn }}</td>
      <td>{{ data.batchNumber }}</td>
      <td>
        <div nzFormat="dd/MM/yyyy">
          {{ data.expiredDate | date: "dd/MM/yyyy" }}
        </div>
      </td>
      <td>{{ data.serialNumber }}</td>
      <td>{{ data.unitSmallest }}</td>
      <td>{{ data.chemical?.packingQuantity }} {{ data.unitTypeText }}/{{ data.chemical?.packing }}</td>
      <td>{{ data.chemical?.packingUnit }}</td>
      <td>
        <div>
          {{ data.amount }} {{ data.unitTypeText }}
        </div>
      </td>
      <td>
        <div>
          {{ data.price | number:'1.0-2'}}
        </div>
      </td>
      <td>
        <div>
          {{ data.totalPrice | number:'1.0-2' }}
        </div>
      </td>
      <!--<td>
        <div>
          {{ data.batchCode }}
        </div>
      </td>-->
    </tr>
    </tbody>
  </nz-table>

  <div *nzModalFooter>
    <button nz-button (click)="handleCancelView()">{{'cancel' | translate }}</button>
  </div>
</nz-modal>
<!-- <div id="div-barcode" *ngIf="arrBarcodes.length" style="display: none;background: #FFF;">
  <ng-container *ngFor="let rows of arrColumnBarcodes">
    <div style="display: flex;height: 11.5mm; width: 66mm; margin-left: 2mm;">
      <ng-container *ngFor="let item of rows">
        <div style="display: block;width: 18mm; padding-left: 2.5mm">
          <ngx-barcode [bc-font-size]="9" [bc-margin]="1" [bc-width]="0.8" [bc-height]="16"
                       [bc-font]=""
                       [bc-value]="item.barCode" bc-element-type="svg" [bc-display-value]="true"
                       [bc-margin-top]="9"
                       [bc-margin-bottom]="1"
                       [bc-margin-left]="1"
                       [bc-margin-right]="1"
          ></ngx-barcode>
        </div>
      </ng-container>

    </div>
  </ng-container>
</div> -->

<div id="div-barcode" *ngIf="arrBarcodes.length" style="display: none;background: #FFF;">
  <ng-container *ngFor="let rows of arrColumnBarcodes">
    <div style="display: flex;height: 10.8mm;margin-left: 2mm;">
      <ng-container *ngFor="let item of rows">
        <div style="display: block;width: 18mm;padding: 0 1mm">
          <ngx-barcode [bc-font-size]="9" [bc-margin]="1" [bc-width]="1" [bc-height]="barcodeConfig.barCodeHeight"
                       [bc-font]=""
                       [bc-value]="item.barCode" bc-element-type="svg" [bc-display-value]="true"
                       [bc-margin-top]="1"
                       [bc-margin-bottom]="1"
                       [bc-margin-left]="1.6"
                       [bc-margin-right]="1"
          ></ngx-barcode>
        </div>
      </ng-container>
</div>
